<template>
  <div class="profile">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="header">
            <h3 class="subtitle">{{ $t('profile.personalInformation') }}</h3>
          </div>
          <div class="content">
            <!-- icon edit start -->
            <!-- <router-link to="/home/user/edit">
              <i
                v-b-tooltip.hover
                class="fa fa-pencil float-right edit-icon"
                aria-hidden="true"
                :title="$t('editProfileStudent.editYourInformation')"
              ></i>
            </router-link> -->
            <!-- #icon edit end -->
            <!-- photo of student start -->
            <div class="avatar">
              <img v-if="user.avatar" :src="user.avatar" alt="avatar" class="rounded-circle avatar-img" />
              <img v-else src="@/assets/avatars/user_generic.jpg" alt="avatar" class="rounded-circle avatar-img" />
            </div>
            <!-- #photo of student end -->

            <!-- info of student start -->
            <div class="style-border">
              <label class="text-format">{{ $t('singup.name') }}:</label>
              <span class="text-capitalize">{{ fullName }}</span>
            </div>
            <div class="style-border">
              <label class="text-format">{{ $t('singup.username') }}:</label>
              <span class="text-capitalize">{{ user.username }}</span>
            </div>
            <div class="style-border">
              <label class="text-format">{{ $t('profile.gradeLevel') }}</label>
              <span class="text-capitalize">{{ user.grade_name }}</span>
            </div>
            <div class="style-border">
              <label class="text-format">{{ $t('profile.registreAt') }}</label>
              <span>{{ user.registration_date | date }}</span>
            </div>
          </div>
          <!-- #info of student end -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ProfileStudent',
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      user: 'auth/authenticatedUser',
    }),
    fullName() {
      return this.user.firstname + ' ' + this.user.lastname;
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
a:link {
  text-decoration: none;
}
.profile {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.header {
  background-color: #ff6d00;
  min-height: 12.3rem;
  max-width: 50rem;
  margin: 0 auto;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}
.content {
  min-height: 20rem;
  max-width: 50rem;
  margin: 0 auto;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border: 1px solid #ff6d00;
  background-color: #ffffff;
}
.content label {
  display: block;
}
.edit-icon {
  color: black;
  padding: 0.4rem;
  margin: 1rem 1.5rem;
}
.edit-icon:hover {
  background-color: rgba(0, 96, 151, 0.1);
  border-radius: 50%;
}
.avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
}
.avatar .avatar-img {
  width: 8.5rem;
  height: 8.5rem;
  margin-right: -0.25rem;
  margin-top: -4.25rem;
}
.text-format {
  min-width: 11rem;
  display: inline-block !important;
  margin-bottom: 0;
  margin-top: 0.8rem;
  // margin-bottom: .5rem;
}
.style-border {
  border-bottom: 1px solid #ff6d00;
  color: #727272;
  max-width: 25rem;
  margin: 0 auto;
  padding-bottom: 10px;
}
.subtitle {
  text-align: center;
  font-size: 1.8rem;
  font-weight: 600;
  padding-top: 3rem;
  color: white;
  margin-bottom: 0;
  text-transform: uppercase;
}
/* --------------------------------- */
/* 3. Custom Styles
 ----------------------------------- */
/*Vue transitions*/
</style>
